import styled from 'styled-components';

export const DreamToRealityLPStyles = styled.div`
  h3.h1 {
    color: #fff;
    text-shadow: rgba(0, 0, 0, 0.75) 0px 2px 4px;
    margin-bottom: 10px;
  }
  p.standard {
    color: #fff;
    line-height: 130%;
    margin-bottom: 20px;
    text-shadow: rgba(0, 0, 0, 0.75) 0px 2px 4px;
  }

  .LPMcontainer {
    /* Required to override the element style on this page from LivePerson. */
    inset: 80% 0px auto auto !important;
  }
`;

export default DreamToRealityLPStyles;
